module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_adults_bg-31ce71c620cc4d27761eae6aaeaf36c4.png";